import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'underscore';

import { showNotification } from '../../../actions/notificationActions';
import { setSaveAsOnDemandOption } from '../../../actions/liveManagerActions';
import { IconsList } from '../../../reusable/IconsStore/IconsList';
import IconsStore from '../../../reusable/IconsStore/IconsStore';
import { liveEventStatusList } from '../../../constants/liveEventStatus';
import {
	mediaNames,
	messageTypes,
	imageRelTagList,
	MEET_LIVE_COVER_PROPERTY,
	UPLOAD_FAILED,
	UPLOADING_FILE,
} from '../../../constants/mediaConstants';
import MeetLiveCoverToggle from './MeetLiveCoverToggle';
import ConfirmationDialog from '../../../reusable/ConfirmationDialog/ConfirmationDialog';
import { isMeetFormAttached } from '../../../actions/meetActions';
import { renewMeetJoin } from '../../../actions/liveManagerActions';
import { getDetails } from '../../../services/mediaDisplayService';
import {
	getMediaQueryDetails,
	removeThumbnailImage,
	stopMediaUploadProcess,
	startMediaUploadProcess,
	startThumbImageUploadProcess,
	setTheThumbnailImageAsDefaultAction,
	keepLoadResourcesAfterTheFlowStarted,
	updateResourceOfMedia,
	removeResourceAsThumbnail,
	updateMediaCover,
	removeSubtitle,
	getAllCurrentJobs,
	setUploadingProcessActive,
	saveInspectScreenDetails,
} from '../../../actions/publishActions';
import { setIsElementUpdating } from '../../../actions/interactElementsActions';
import { showAlert, showMessage } from '../../../actions/globalActions';
import {
	removeTagFromRelOfResource,
	addTagToRelOfResource,
	getResourceOfMediaWithTag,
	getResourceOfMediaById,
} from '../../../services/mediaResourceService';
import { generateId } from '../../../services/stringHelperService';

import './LiveCoversUpload.scss';

class LiveCoversUpload extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showloading: false,
			selectedCoverResource: '',
			onOngoingFilePercent: '',
			// null until the lookup answers; false means meet cannot resolve this media at all
			hasMeetForm: null,
			showFormRequiredDialog: false,
		};
	}

	UNSAFE_componentWillMount = () => {
		this.fetchAndSetMediaDetails();
	};

	componentDidMount = () => {
		this.checkMeetForm();
		// Attaching a form happens on another screen, so coming back to this window is the moment
		// to look again - that is when the answer is most likely to have changed.
		window.addEventListener('focus', this.checkMeetForm);
	};

	componentWillUnmount = () => {
		window.removeEventListener('focus', this.checkMeetForm);
	};

	componentDidUpdate = (nextProps) => {
		if (this.props.isVisible !== nextProps.isVisible) {
			this.fetchAndSetMediaDetails();
			this.checkMeetForm();
		}
	};

	// Only the meet live cover depends on the form; the other covers are read from the media by the
	// player and do not care.
	checkMeetForm = () => {
		const { coverName, mediaId } = this.props;
		if (coverName !== imageRelTagList.MEET_LIVE_COVER || !mediaId) {
			return;
		}
		this.props.isMeetFormAttached(mediaId).then((hasMeetForm) => {
			const wasMissing = this.state.hasMeetForm === false;

			this.setState({ hasMeetForm });

			// The embedded meeting resolved this media once, when it joined, and found no form. It
			// never looks again, so it is still running blind against that answer - make it rejoin
			// now that there is something to find, rather than leaving the operator to work out
			// that a reload is needed.
			if (wasMissing && hasMeetForm) {
				this.props.renewMeetJoin();
			}
		});
	};

	fetchAndSetMediaDetails = (_) => {
		const { defaultAccountId, t, coverName, mediaId } = this.props;
		this.props.getMediaQueryDetails(defaultAccountId, mediaId, mediaNames.medias).then((media) => {
			if (!media) {
				this.props.showMessage(t('COMMON_MEDIA_NOT_FOUND'), messageTypes.error);
				return;
			}
			if (typeof media == 'string') {
				this.props.showMessage(media, messageTypes.error);
				return;
			}
			this.updateMediaDetails(media);
			let selectedCoverResource = '';
			if (
				coverName === imageRelTagList.THUMBNAIL &&
				media.thumbnails &&
				media.thumbnails.length > 0 &&
				media.thumbnails[0].id
			) {
				selectedCoverResource = getResourceOfMediaById(media, media.thumbnails[0].id);
			} else {
				selectedCoverResource = getResourceOfMediaWithTag(media, coverName);
			}
			this.setState({
				selectedCoverResource: selectedCoverResource || '',
			});
		});
	};

	updateMediaDetails = (media) => {
		const { mediaName } = this.props;
		const customMediaInfo = getDetails(media, mediaName === mediaNames.playlists);
		this.setState({ mediaDetails: customMediaInfo });
	};

	openDropZoneSelection = () => {
		this.refs.dropzone.open();
	};

	setLoading = () => {
		this.setState({ showloading: true });
		this.props.setIsElementUpdating(true);
	};

	resetLoading = () => {
		this.setState({ showloading: false });
		this.props.setIsElementUpdating(false);
	};

	getPercentage = (expense, total) => {
		return Math.round((expense / total) * 100);
	};

	trackUploadStatus = (eachFile, uid) => {
		const { defaultAccountId, t } = this.props;
		let file = '';
		this.props
			.getAllCurrentJobs(defaultAccountId)
			.then((data) => {
				if (data && data.length > 0) {
					file = _.find(data, (eachData) => {
						return eachData.uid.trim() === uid.trim();
					});
				}
				if (file) {
					let num = file.distans;
					num = num.split('/');
					let percent = this.getPercentage(num[0], num[1]);
					this.setState({
						onOngoingFilePercent: percent,
					});
					setTimeout(() => {
						this.trackUploadStatus(eachFile, uid);
					}, 500);
				} else {
					this.setState({
						onOngoingFilePercent: '',
					});
					setTimeout(
						(eachFile) => {
							this.getSelectedMedia(eachFile, () => {
								this.tryFetchingMediaAgain(eachFile, 0, t);
							});
							this.resetLoading();
						},
						1000,
						eachFile
					);
				}
			})
			.catch((error) => {
				setTimeout(
					(eachFile) => {
						this.getSelectedMedia(eachFile, () => {
							this.tryFetchingMediaAgain(eachFile, 0, t);
						});
						this.resetLoading();
					},
					0,
					eachFile
				);
				return error;
			});
	};

	tryFetchingMediaAgain = (eachFile, count, t) => {
		let countDown = count;
		if (countDown < 3) {
			setTimeout(
				(eachFile) => {
					this.getSelectedMedia(eachFile, () => {
						countDown = countDown + 1;
						this.tryFetchingMediaAgain(eachFile, countDown, t);
						this.props.showMessage(
							t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_RE_FETCHED_MEDIA'),
							messageTypes.info
						);
					});
				},
				2000,
				eachFile
			);
		} else {
			this.resetLoading();
		}
	};

	getFileWithRandomName = (file) => {
		const newName = generateId() + '.' + file.name.split('.').pop();
		const options = { type: file.type, lastModified: file.lastModified };
		try {
			// If this call fails, we go for Blob
			return new File([file], newName, options);
		} catch (e) {
			// If we reach this point a new File could not be constructed
			var myBlob = new Blob([file], options || {});
			myBlob.name = newName;
			return myBlob;
		}
	};

	loadTheSelectedMediaItems = (files) => {
		const { defaultAccountId, t, setUploadingProcessActive } = this.props;
		const { mediaDetails } = this.state;
		let eachFile = this.getFileWithRandomName(files[0]);
		let assetId = '';
		if (mediaDetails && mediaDetails.asset && mediaDetails.asset.id) {
			assetId = mediaDetails.asset.id;
			this.setLoading(eachFile);
			setUploadingProcessActive(UPLOADING_FILE);

			this.props.startThumbImageUploadProcess(defaultAccountId, eachFile, assetId).then((res) => {
				setTimeout(() => setUploadingProcessActive(''), 1000);

				if (!res || res === UPLOAD_FAILED) {
					this.props.showAlert(t('COMMON_UPLOAD_FAILED'), messageTypes.error);
					this.resetLoading();
					return;
				}

				if (res && res.data && typeof res.data === 'string') {
					let uid = res.data.split('uid:');
					uid = uid.length > 0 ? uid[1] : '';
					setTimeout(() => {
						this.trackUploadStatus(eachFile, uid);
					}, 500);
				}
			});
		} else {
			this.props.showMessage(
				t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_FAILED_PROCESS_NO_ASSET_ID'),
				messageTypes.error
			);
		}
	};

	getSelectedMedia = (eachFile, callback) => {
		const { defaultAccountId, t, coverName, mediaId } = this.props;
		const { currentResouceId, mediaDetails } = this.state;
		this.setLoading();
		let assetId = mediaDetails.asset.id;
		let fileFound = false;
		this.props.getMediaQueryDetails(defaultAccountId, mediaDetails.id, mediaNames.medias).then((media) => {
			if (!media) {
				this.props.showMessage(t('COMMON_MEDIA_NOT_FOUND'), messageTypes.error);
				this.resetLoading();
				return;
			}
			let resourceArray = [];
			if (media && media.asset && media.asset.resources && media.asset.resources.map) {
				resourceArray = media.asset.resources.filter(
					(eachResource) => eachResource && eachResource.type === 'image' && eachResource.renditions
				);
				if (resourceArray.length > 0) {
					if (!fileFound) {
						resourceArray.map((resource) => {
							resource.renditions.map((rendition) => {
								if (
									!fileFound &&
									rendition.path.match(eachFile.name) &&
									// The backend stores 0 as the size for some images. A size that
									// can never match means the upload is never recognised as ours,
									// so the rel tag and the cover sequence are never written and
									// the cover stays invisible. Treat 0 as "unknown" instead.
									(!rendition.size || rendition.size === eachFile.size)
								) {
									if (currentResouceId) {
										// to check if old resource is to be deleted or not
										this.props.removeSubtitle(defaultAccountId, assetId, currentResouceId); //here removeSubtitle is actually removing a resource
									}
									fileFound = true;
									this.setState(
										{
											currentResouceId: resource.id,
										},
										() => {
											if (coverName === imageRelTagList.THUMBNAIL) {
												this.props
													.setTheThumbnailImageAsDefaultAction(
														defaultAccountId,
														mediaId,
														resource.id
													)
													.then((res) => {
														if (res) {
															this.props.showMessage(
																t(
																	'MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_THUMBNAIL_UPDATED'
																),
																messageTypes.info
															);
															this.updateRelArrayWithTag(resource, coverName);
														}
													});
											} else {
												this.updateRelArrayWithTag(resource, coverName);
											}
										}
									);
									this.resetLoading();
								}
							});
						});
					} //end of if not filefound
				}
			}
			if (!fileFound && callback) {
				callback();
			} else if (!fileFound) {
				this.props.showMessage(
					t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_FILE_NOT_FOUND'),
					messageTypes.error
				);
			}
			this.resetLoading();
		});
	};

	removeTagFromOtherResources = (currentResourceId, tag, callback) => {
		const { defaultAccountId, t } = this.props;
		const { mediaDetails } = this.state;
		if (mediaDetails && !mediaDetails.asset) {
			this.props.showMessage(
				t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_FAILED_PROCESS_NO_ASSET_ID'),
				messageTypes.error
			);
			return;
		}
		let assetId = mediaDetails.asset.id;
		let allImageResources =
			mediaDetails.asset.resources &&
			mediaDetails.asset.resources.filter(
				(eachImageResource) => eachImageResource.type === 'image' && eachImageResource.renditions
			);

		let resources = allImageResources.filter(
			(eachImageResource) =>
				eachImageResource.id &&
				eachImageResource.id !== currentResourceId &&
				eachImageResource.rel &&
				eachImageResource.rel.length > 0 &&
				eachImageResource.rel.indexOf(tag) !== -1
		);
		if (resources.length > 0) {
			let count = 0;
			let resourcesLength = resources.length;
			resources.map((eachImageResource) => {
				eachImageResource = removeTagFromRelOfResource(eachImageResource, tag);
				this.props.updateResourceOfMedia(defaultAccountId, assetId, eachImageResource).then((_) => {
					count = count + 1;
					if (resourcesLength === count) {
						if (callback) {
							callback();
						}
					}
				});
			});
		} else {
			if (callback) {
				callback();
			}
		}
	};

	updateRelArrayWithTag = (resource, tag) => {
		const { defaultAccountId, t } = this.props;
		const { mediaDetails } = this.state;
		if (mediaDetails && !mediaDetails.asset) {
			this.props.showMessage(
				t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_FAILED_PROCESS_NO_ASSET_ID'),
				messageTypes.error
			);
			return;
		}
		resource = addTagToRelOfResource(resource, tag);
		let assetId = mediaDetails.asset.id;
		this.removeTagFromOtherResources(resource.id, tag, () => {
			this.props.updateResourceOfMedia(defaultAccountId, assetId, resource).then((res) => {
				if (res && (!res.message || !res.Message)) {
					if (tag === imageRelTagList.PRECOVER) {
						this.props.showMessage(
							t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_PRE_COVER_UPDATED'),
							messageTypes.info
						);
						this.updatePrecoverInTracks(resource, 'add');
					} else if (tag === imageRelTagList.POSTCOVER) {
						this.props.showMessage(
							t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_POST_COVER_UPDATED'),
							messageTypes.info
						);
					} else if (tag === imageRelTagList.MEET_LIVE_COVER) {
						// Deliberately no updatePrecoverInTracks here. That writes into the cover
						// track, and a cover sequence that is open reads to the player as "the live
						// event ended" - the meet live cover never goes near it.
						this.props.showMessage(
							t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_MEET_LIVE_COVER_UPDATED'),
							messageTypes.info
						);
						// Tagging the resource is invisible to meet on its own, so a meeting that
						// is already covered would go on showing the old picture. The wait matches
						// the refresh below: the read model needs a moment before it reports the
						// new tag, and meet answers this notification by re-reading the media.
						setTimeout(() => {
							this.saveMeetLiveCoverCustom();
						}, 3000);
					}
					setTimeout(() => {
						this.fetchAndSetMediaDetails();
					}, 3000);
				} else {
					this.props.showMessage(
						t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_FAILED_TO_UPDATE'),
						messageTypes.error
					);
				}
			});
		});
	};

	removeTagFromResourceAndUpdate = (resource) => {
		const { t, defaultAccountId, mediaId, coverName } = this.props;
		const { mediaDetails } = this.state;
		if (mediaDetails && !mediaDetails.asset) {
			this.props.showMessage(
				t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_FAILED_PROCESS_NO_ASSET_ID'),
				messageTypes.error
			);
			return;
		}
		if (!resource || (resource && !resource.id)) {
			this.props.showMessage(
				t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_RESOURCE_ID_NOT_FOUND'),
				messageTypes.error
			);
			return;
		}
		const assetId = mediaDetails.asset.id;
		if (coverName === imageRelTagList.THUMBNAIL) {
			this.props.removeResourceAsThumbnail(defaultAccountId, mediaId, resource.id).then((res) => {
				if (res) {
				} else {
					this.props.showMessage(
						t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_DETAILS_IMAGE_MANAGER_FAILED_TO_PROCESS'),
						messageTypes.error
					);
				}
			});
		}
		resource = removeTagFromRelOfResource(resource, coverName);
		this.props.updateResourceOfMedia(defaultAccountId, assetId, resource).then((res) => {
			if (res) {
				this.props.showMessage(coverName + ` ${t('COMMON_REMOVED')}`, messageTypes.info);
				if (coverName === imageRelTagList.PRECOVER) {
					this.updatePrecoverInTracks(resource, 'delete');
				} else if (coverName === imageRelTagList.MEET_LIVE_COVER) {
					this.clearMeetLiveCoverFlag();
				}
			}
			setTimeout(() => {
				this.fetchAndSetMediaDetails();
			}, 2000);
		});
	};

	/**
	 * Writes the media's custom object back, optionally setting the live cover flag on the way.
	 *
	 * Meet hears about this media through the custom property notification and nothing else.
	 * Tagging a resource raises no such notification, so re-writing the custom object is the only
	 * way to tell a meeting that is already covered that the picture underneath it has changed.
	 * Called with no argument it changes nothing and exists purely to raise that notification.
	 */
	saveMeetLiveCoverCustom = (nextValue) => {
		const { defaultAccountId, mediaId } = this.props;
		this.props.getMediaQueryDetails(defaultAccountId, mediaId, mediaNames.medias).then((media) => {
			if (!media || typeof media === 'string') {
				return;
			}
			const details = getDetails(media, false);
			if (!details || !details.asset) {
				return;
			}

			const livemanager = { ...(details.custom?.livemanager ?? {}) };
			if (nextValue !== undefined) {
				livemanager[MEET_LIVE_COVER_PROPERTY] = nextValue;
			}

			this.props.saveInspectScreenDetails(defaultAccountId, mediaId, mediaNames.medias, {
				id: details.id,
				asset: { id: details.asset.id },
				metadata: details.metadata,
				tags: details.tags,
				custom: { ...(details.custom ?? {}), livemanager },
				links: details.links,
			});
		});
	};

	// Removing the image has to take the flag with it. An enabled cover with no picture left to
	// show would blank the meeting stage in the broadcast. Written as false rather than removed,
	// so meet can read the state straight off the notification instead of re-reading the media.
	clearMeetLiveCoverFlag = () => this.saveMeetLiveCoverCustom(false);

	updatePrecoverInTracks = (resource, operation) => {
		const { mediaDetails } = this.state;
		let tracks = mediaDetails.tracks || [];
		if (!tracks) {
			return;
		}
		let gotTypeCover = false;
		tracks.map((track) => {
			let trackId = track.id;
			if (track && track.sequences && track.sequences[0].type === 'cover' && !gotTypeCover) {
				gotTypeCover = true;
				let bodyObj = track.sequences[0];
				let coverId = bodyObj.id;
				let cover = bodyObj;
				if (cover && !cover.resource) {
					cover['resource'] = {};
				}
				if (operation === 'add' && resource.id) {
					cover.resource.id = resource.id;
					this.updateMediaCover(trackId, coverId, cover);
				} else if (operation === 'delete') {
					cover.resource.id = '';
					this.updateMediaCover(trackId, coverId, cover);
				}
			}
		});
	};

	updateMediaCover = (trackId, coverId, cover) => {
		const { t, defaultAccountId, mediaId } = this.props;
		this.props.updateMediaCover(defaultAccountId, mediaId, trackId, coverId, cover).then((res) => {
			if (!res) {
				this.props.showMessage(
					t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_PRE_COVER_UPDATING_IN_TRACKS_FAILED'),
					messageTypes.error
				);
			}
		});
	};

	previewImage = () => {
		const { selectedCoverResource } = this.state;
		window.open(selectedCoverResource.renditions[0].links[0].href, '_blank');
	};

	getDropZone = (selectedfile) => {
		const { t, showMessage } = this.props;

		// Meet resolves this media only through the form that owns its room, so a cover uploaded
		// without one can never reach the meeting. Blocked here rather than after the upload: the
		// picture would look uploaded, the switch would report success, and nothing would happen.
		const needsForm = this.state.hasMeetForm === false;

		return (
			<div
				onClickCapture={
					needsForm
						? (event) => {
								event.preventDefault();
								event.stopPropagation();
								this.setState({ showFormRequiredDialog: true });
						  }
						: undefined
				}
			>
				<Dropzone
					disabled={needsForm}
					ref="dropzone"
					multiple={false}
					accept=".jpg, .jpeg, .gif, .png, .bmp"
					parallelChunkUploads={true}
					onDrop={(acceptedFiles, fileRejections) => {
						if (fileRejections.length > 0) {
							showMessage(t('COMMON_LABEL_NOT_SUPPORTED_FILES'), messageTypes.error);
							return;
						}
						this.loadTheSelectedMediaItems(acceptedFiles);
					}}
					onFileDialogCancel={this.clearTheFilesSelection}
					inputContent={(files, extra) =>
						extra.reject
							? t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_IMAGE_FILES_ONLY')
							: t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_DRAG_FILES')
					}
				>
					{({ getRootProps, getInputProps }) => (
						<>
							<div className="dropzoneContainer">
								<div {...getRootProps({ className: 'dropzone' })}>
									<input {...getInputProps()} />
									{selectedfile ? (
										<>
											<Button className="defaultActionBtn"> {t('COMMON_REPLACE')}</Button>
										</>
									) : (
										<>
											<Button className="defaultActionBtn">
												<IconsStore
													className="closeIcon"
													iconName={IconsList.CARD_IMAGE}
													color={'#ffffff'}
												/>
												{t('COMMON_CHOOSE_FILE')}
											</Button>
										</>
									)}
								</div>
							</div>
						</>
					)}
				</Dropzone>
			</div>
		);
	};

	render() {
		const { selectedCoverResource, showloading, onOngoingFilePercent } = this.state;
		const { coverName, liveEventStatus, mediaId, t } = this.props;

		const isMeetLiveCover = coverName === imageRelTagList.MEET_LIVE_COVER;
		// Only the meet live cover is frozen once the event starts - it is the one picture that is
		// already inside a running broadcast, and swapping it mid-stream would change what viewers
		// are looking at without anyone asking for it. The other covers keep their old behaviour.
		const isImageLocked = isMeetLiveCover && liveEventStatus !== liveEventStatusList.INITIAL;

		// A resource is tagged the moment it is uploaded, but its renditions appear only once the
		// backend has processed it. Reaching into renditions[0] unguarded threw in that window and
		// took the whole section down with it, which looked like the upload had vanished.
		let fileName = '';
		if (selectedCoverResource && selectedCoverResource.renditions?.[0]?.path) {
			let path = selectedCoverResource.renditions[0].path;
			path = path.split('/');
			fileName = path[path.length - 1];
		}
		return (
			<>
				<div id="coverUploads">
					{showloading && (
						<LinearProgress
							className={'loadingProgressBar'}
							style={{
								background: 'transparent',
							}}
							variant="determinate"
							value={onOngoingFilePercent}
						/>
					)}

					{selectedCoverResource && selectedCoverResource.renditions && (
						<div className={`coverImage${isMeetLiveCover ? ' coverImageWithToggle' : ''}`}>
							<div className="loadedImageContainer" onClick={this.previewImage}>
								<img className="loadedImage" src={selectedCoverResource.renditions[0].links[0].href} />
								{fileName ? <label> {fileName} </label> : null}
							</div>
							{!isImageLocked && (
								<>
									<div className="replaceButton">{this.getDropZone(selectedCoverResource)}</div>
									<div
										className="removeResource"
										onClick={() => this.removeTagFromResourceAndUpdate(selectedCoverResource)}
									>
										<IconsStore
											className="closeIcon"
											iconName={IconsList.CLOSE}
											color={'#ffffff'}
										/>
									</div>
								</>
							)}
							{/* Last child on purpose: it is the one that wraps onto a second line
							    inside this box, so it has to come after the buttons rather than
							    pushing them down with it.

							    Keyed on the picture: a replaced image is a write to the media the
							    switch did not make, so it starts again and re-reads the flag rather
							    than trusting what it last set. */}
							{isMeetLiveCover && (
								<MeetLiveCoverToggle
									key={selectedCoverResource.id}
									mediaId={mediaId}
									hasCoverImage={true}
									hasMeetForm={this.state.hasMeetForm}
								/>
							)}
						</div>
					)}
					{/* `||`, not `&&`: a resource with no renditions yet matched neither this branch
					    nor the one above, so the section rendered empty - no image and no way to
					    upload one. Falling back to the upload button at least leaves a way out. */}
					{(!selectedCoverResource || !selectedCoverResource.renditions) && !isImageLocked && (
						<div className="newButton">{this.getDropZone()}</div>
					)}
				</div>

				{this.state.showFormRequiredDialog && (
					<ConfirmationDialog
						title={t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_MEET_FORM_REQUIRED_TITLE')}
						message={t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_MEET_FORM_REQUIRED_MESSAGE')}
						okButtonText={t('COMMON_OK')}
						noCancelButton={true}
						callback={() => {
							this.setState({ showFormRequiredDialog: false });
							// They may have gone and attached one in the meantime, so ask again
							// rather than make them reload the page to get the upload back.
							this.checkMeetForm();
						}}
						t={t}
					/>
				)}
			</>
		);
	}
}

const mapStateToProps = ({ session, notification, liveManager }) => ({
	defaultAccountId: session.defaultAccountId,
	message: notification.message,
	open: notification.showNotification,
	liveEventStatus: liveManager.liveEventStatus,
	SaveAsOnDemand: liveManager.SaveAsOnDemand,
});

const mapDispatchToProps = (dispatch) => ({
	stopMediaUploadProcess: (_) => dispatch(stopMediaUploadProcess()),
	setSaveAsOnDemandOption: (boolStatus) => dispatch(setSaveAsOnDemandOption(boolStatus)),
	showNotification: (message) => dispatch(showNotification(message)),
	removeThumbnailImage: (accId, id, resourceId) => dispatch(removeThumbnailImage(accId, id, resourceId)),
	getMediaQueryDetails: (accId, mediaId, mediaName) => dispatch(getMediaQueryDetails(accId, mediaId, mediaName)),
	startThumbImageUploadProcess: (accId, file, assetId) =>
		dispatch(startThumbImageUploadProcess(accId, file, assetId)),
	startMediaUploadProcess: (onGoingfiles, selectedFiles) =>
		dispatch(startMediaUploadProcess(onGoingfiles, selectedFiles)),
	keepLoadResourcesAfterTheFlowStarted: (accId, assetId, status) =>
		dispatch(keepLoadResourcesAfterTheFlowStarted(accId, assetId, status)),
	updateResourceOfMedia: (accountId, assetId, resource) =>
		dispatch(updateResourceOfMedia(accountId, assetId, resource)),
	removeSubtitle: (accountId, assetId, resourceId) => dispatch(removeSubtitle(accountId, assetId, resourceId)),
	setTheThumbnailImageAsDefaultAction: (accId, mediaId, resourceId) =>
		dispatch(setTheThumbnailImageAsDefaultAction(accId, mediaId, resourceId)),
	removeResourceAsThumbnail: (accId, mediaId, resourceId) =>
		dispatch(removeResourceAsThumbnail(accId, mediaId, resourceId)),
	getAllCurrentJobs: (accountId) => dispatch(getAllCurrentJobs(accountId)),
	isMeetFormAttached: (mediaId) => dispatch(isMeetFormAttached(mediaId)),
	renewMeetJoin: () => dispatch(renewMeetJoin()),
	saveInspectScreenDetails: (accountId, mediaId, mediaName, body) =>
		dispatch(saveInspectScreenDetails(accountId, mediaId, mediaName, body)),
	updateMediaCover: (accId, mediaId, trackId, coverId, cover) =>
		dispatch(updateMediaCover(accId, mediaId, trackId, coverId, cover)),
	showMessage: (stackMessage, type) => dispatch(showMessage(stackMessage, type)),
	setIsElementUpdating: (isUpdating) => dispatch(setIsElementUpdating(isUpdating)),
	showAlert: (value, type) => dispatch(showAlert(value, type)),
	setUploadingProcessActive: (value) => dispatch(setUploadingProcessActive(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(LiveCoversUpload);
